import type { VariableCategoryView } from '@/api/variable'

export interface CategoryOption {
  value: string | number
  label: string
  disabled?: boolean
  children?: CategoryOption[]
}

export function categoryChildren(categories: VariableCategoryView[], parentId: number): VariableCategoryView[] {
  return categories.filter(c => c.parent_id === parentId).sort((a, b) => a.sort - b.sort || a.id - b.id)
}

export function categoryRoots(categories: VariableCategoryView[]): VariableCategoryView[] {
  return categories.filter(c => !c.parent_id).sort((a, b) => a.sort - b.sort || a.id - b.id)
}

export function categoryOptions(categories: VariableCategoryView[]): CategoryOption[] {
  return [true, false].map(visible => {
    const roots = categoryRoots(categories).filter(c => c.app_visible === visible)
    return {
      value: visible ? 'visible' : 'hidden',
      label: visible ? 'APP 显示' : 'APP 不显示',
      disabled: roots.length === 0,
      children: roots.map(root => {
        const children = categoryChildren(categories, root.id)
        return {
          value: root.id,
          label: root.name,
          ...(children.length ? { children: children.map(c => ({ value: c.id, label: c.name })) } : {})
        }
      })
    }
  })
}

export function categoryPath(categories: VariableCategoryView[], id: number | null): Array<string | number> {
  const category = categories.find(c => c.id === id)
  if (!category) return []
  const root = category.parent_id ? categories.find(c => c.id === category.parent_id && !c.parent_id) : category
  if (!root) return []
  return [root.app_visible ? 'visible' : 'hidden', root.id, ...(category.parent_id ? [category.id] : [])]
}

export function categoryLeaves(categories: VariableCategoryView[], visible: boolean): VariableCategoryView[] {
  return categoryRoots(categories).filter(c => c.app_visible === visible).flatMap(root => {
    const children = categoryChildren(categories, root.id)
    return children.length ? children : [root]
  })
}

export function categoryLabel(categories: VariableCategoryView[], category: VariableCategoryView): string {
  const parent = categories.find(c => c.id === category.parent_id)
  return parent ? `${parent.name} / ${category.name}` : category.name
}

export function categoryContains(categories: VariableCategoryView[], selected: number, member: number | null): boolean {
  return member === selected || categories.some(c => c.id === member && c.parent_id === selected)
}
